import React from 'react'
import Link from '../Link'
import styled from 'styled-components'
import {beUrl} from "../../../config";

const GlossaryLink = () => {

  return (
    <Container>
        <Link link={`${beUrl}/assistenza?go-to=glossary`} text={'VAI AL GLOSSARIO'}/>
    </Container>
  )
}

const Container = styled.div`
  
`

export default GlossaryLink
